var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import LogoWithMono from '../../../LogoWithMono';
const LogoCfl = (_a) => {
    var commonProps = __rest(_a, []);
    const source = {
        content: (React.createElement("svg", { width: 52, height: 18, viewBox: "0 0 52 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.318217 11.1663C-0.816783 12.879 1.44922 12.991 1.44922 12.991H9.19922L10.3722 11.1653H3.58322L6.27122 6.85169H21.8122L23.0052 5H5.72222C4.37122 5 3.54922 6.15943 3.54922 6.15943C3.54922 6.15943 1.45822 9.45467 0.318217 11.1663ZM33.616 5.00598L33.043 5.89331H41.92L44.514 9.23457H47.811L50.554 5.00598H33.616ZM48.8695 13L49.4215 12.1446H42.6285L40.0255 8.81738H36.7285L34.0195 13H48.8695ZM41.5622 6.45154L44.1552 9.78479H50.9582L50.5672 10.39H43.7552L41.1612 7.07278H32.2772L32.6782 6.45154H41.5622ZM43.3978 10.9652L40.7968 7.63293H31.9128L31.5078 8.25517H40.3918L42.9908 11.5824H49.7948L50.1938 10.9712L43.3978 10.9652ZM21.3733 7.52893H13.5153L9.98828 12.991H13.9253L16.3683 9.20156H20.2913L21.3733 7.52893ZM27.7242 5L23.6612 11.2924H32.5522L31.5052 12.991H18.6372L23.7862 5H27.7242Z", fill: "#B90D35" }))),
        alt: 'Cfl',
    };
    return React.createElement(LogoWithMono, Object.assign({}, commonProps, { fixedHeight: 18, source: source }));
};
export default LogoCfl;
//# sourceMappingURL=index.js.map